// extracted by mini-css-extract-plugin
module.exports = {"myInput":"MyInput_myInput__26Fgy"};